import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import Typography from '@material-ui/core/Typography';
// import Grid from '@material-ui/core/Grid';
import FilterIcon from '../../images/icon_options.png';
import Dialog from '@material-ui/core/Dialog';
import AdvancedFiltersComp from '../AdvancedFilters/AdvancedFilter';
import Hidden from '@material-ui/core/Hidden';
import Slide from '@material-ui/core/Slide';
import 'rc-slider/assets/index.css';

/**
 *
 * Note the code pertaining to small screens is dead code. We have a seperate mobile component
 */
const styles = theme => ({
  headline: {
    color: '#333',
    fontSize: '24px',
    [theme.breakpoints.down('sm')]: {
      padding: '15px 25px 15px',
      fontSize: '14px',
      fontWeight: '600',
      borderBottom: `1px solid #d5d8db`,
      // marginBottom: '100px'
    }
  },
  formControl: {
    marginTop: '35px'
  },
  group: {
    margin: `${theme.spacing.unit}px 0`
  },
  formLabel: {
    minWidth: '250px',
    paddingBottom: '10px',
    color: theme.palette.common.black
  },
  formLabelSliders: {
    paddingBottom: '20px',
    minWidth: '250px',
    color: theme.palette.common.black
  },
  border: {
    border: `1px solid ${theme.palette.secondary.light}`,
    marginRight: '20px',
    borderRadius: '2px'
  },
  borderLeft: {
    marginLeft: '10px',
    border: `1px solid ${theme.palette.secondary.light}`,
    borderRadius: '2px'
  },
  slider: {
    margin: '20px 0'
  },
  sliderSymbols: {
    marginTop: '8px',
    marginRight: '10px',
    color: theme.palette.secondary.dark
  },
  times: {
    color: theme.palette.secondary.dark
  },
  filterIcon: {
    display: 'none',
    [theme.breakpoints.down('sm')]: {
      display: 'inline-flex',
      height: '20px',
      float: 'right',
      cursor: 'pointer'
    }
  },
  hideMobile: {
    [theme.breakpoints.down('sm')]: {
      display: 'none'
    }
  },

  headerMobile: {
    padding: '20px',
    marginBottom: '20px'
  }
});

function Transition(props) {
  return <Slide direction="up" {...props} />;
}

class AdvancedFilters extends Component {
  static propTypes = {
    classes: PropTypes.object,
    filters: PropTypes.object,
    onHoleChange: PropTypes.func,
    onCartChange: PropTypes.func
  };
  state = {
    open: false
  };

  handleClickOpen = () => {
    this.setState({ open: true });
    this.props.onOpened();
  };

 handleClose = () => {
    this.setState({ open: false });
  };

  render() {
    const { classes, ...advFiltersPayload } = this.props;
    return (
      <div>
        <Typography variant="headline" className={classes.headline}>
          Advanced Filters{' '}
          <img
            onClick={this.handleClickOpen}
            src={FilterIcon}
            className={classes.filterIcon}
            alt=""
          />
        </Typography>
        <Hidden smDown>
          <AdvancedFiltersComp {...advFiltersPayload}/>
        </Hidden>
        <Hidden mdUp>
            <Dialog
              fullScreen
              open={this.state.open}
              onClose={this.handleClose}
              TransitionComponent={Transition}
            >

              {/* <Grid item xs={12} sm={12}> */}
              <AdvancedFiltersComp isDialog handleClose={this.handleClose} {...advFiltersPayload}/>
              {/* </Grid> */}

          </Dialog>
        </Hidden>
      </div>
    );
  }
}

export default withStyles(styles)(AdvancedFilters);



// WEBPACK FOOTER //
// ./src/components/AdvancedFilters/index.js